import {Cita} from '../services/citasService';

// Match the coworking/server timezone in receipts, regardless of browser timezone.
export function getTimerUsageSchedule(cita:Cita){
  const arrival=cita.temporizador_inicio_real||cita.temporizador_info?.llegada_real;
  if(arrival&&Number.isFinite(Date.parse(arrival))){
    const date=new Date(arrival),parts=new Intl.DateTimeFormat('en-CA',{timeZone:'America/La_Paz',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(date);
    const value=(type:string)=>parts.find(part=>part.type===type)?.value;
    return {fecha:`${value('year')}-${value('month')}-${value('day')}`,
      horaInicio:new Intl.DateTimeFormat('en-GB',{timeZone:'America/La_Paz',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).format(date),real:true};
  }
  return {fecha:cita.fecha_inicio||null,horaInicio:cita.hora_inicio?.slice(0,5)||null,real:false};
}
